module.exports = __webpack_public_path__ + "static/media/dashboard.d5e7555c.svg";